<template>
    <article
        class="pf-multi-select"
        ref="selectFilter"
        v-click-outside="onClickOutside">
        <div
            class="pf-simple-select__label"
            v-html="label"></div>
        <div class="pf-multi-select__trigger-wrap">
            <button
                @click.prevent="toggleFilterList"
                class="pf-multi-select__trigger"
                :class="{active: filterList, hasValue: filterActiveFieldsId.length !== 0}">
                <span
                    class="pf-multi-select__text"
                    v-html="filterActiveFieldsName.length !== 0 ? filterActiveFieldsName.join(', ') : placeholder">
                </span>
                <button
                    v-if="filterActiveFieldsId.length !== 0"
                    @click.prevent.stop="clearCheckboxes"
                    class="pf-multi-select__clear clear-btn"></button>
            </button>
        </div>
        <div
            v-show="filterList"
            class="pf-multi-select__list-container">
            <div class="pf-multi-select__list-wrap">
                <ul class="pf-multi-select__list">
                    <li
                        v-for="(item, i) in selectData.values"
                        :key="i"
                        class="pf-multi-select__item">
                        <input
                            class="visually-hidden"
                            :name="fieldName"
                            :id="i"
                            :value="i"
                            v-model="filterActiveFieldsId"
                            @change="checkboxesHandler"
                            type="checkbox" />
                        <label
                            :for="i"
                            v-html="item">
                        </label>
                    </li>
                </ul>
            </div>
            <div class="pf-multi-select__btns-wrap">
                <button
                    class="pf-multi-select__btn pf-multi-select__btn--clear"
                    :class="{disabled: filterActiveFieldsId.length === 0}"
                    @click.prevent="clearCheckboxes">
                    Очистить
                </button>
                <button
                    class="pf-multi-select__btn pf-multi-select__btn--apply"
                    :class="{disabled: filterActiveFieldsId.length === 0}"
                    @click.prevent="applyFilter">
                    Применить
                </button>
            </div>
        </div>
    </article>
</template>

<script>
    import vClickOutside from 'click-outside-vue3'

    export default {
        name: 'MultiSelect',
        directives: {
            clickOutside: vClickOutside.directive
        },
        emits: ['choosen-filter-items'],
        data() {
            return {
                filterList: false,
                filterActiveFieldsId: [],
                filterActiveFieldsName: [],
                outputActive: false,
            }
        },
        props: {
            selectData: {
                type: Array,
                default: []
            },
            placeholder: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            fieldName: {
                type: String,
                default: ''
            },
            onloadValue: {
                type: String,
                default: ''
            }
        },
        emits: ['chosen-filter-items'],
        methods: {
            toggleFilterList () {
                if (this.filterList) {
                    this.$emit('choosenFilterItems', this.fieldName, this.filterActiveFieldsId)
                }

                this.filterList = !this.filterList
            },

            checkboxesHandler () {
                this.filterActiveFieldsName = Object.values(this.filterActiveFieldsId).map(el => this.selectData.values[el])
            },

            applyFilter () {
                if (this.filterList) {
                    this.filterList = false
                    this.$emit('choosenFilterItems', this.fieldName, this.filterActiveFieldsId)
                }
            },

            onClickOutside () {
                this.applyFilter()
            },

            clearCheckboxes () {
                this.filterActiveFieldsName = []
                this.filterActiveFieldsId = []
                this.$emit('choosenFilterItems', this.fieldName, this.filterActiveFieldsId)
            }
        },

        created() {
            if (this.onloadValue) {
                const regionsArr = this.onloadValue.split(',')
                this.filterActiveFieldsId = regionsArr
                regionsArr.forEach(el => {
                    this.filterActiveFieldsName.push(this.selectData.values[el])
                })
                
            }
        }
    }
</script>